
import { supabase } from '@/integrations/supabase/client';
import { WizardFormData } from '../types';

export const useLeadAccountSubmit = () => {
  const createLeadAccount = async (formData: WizardFormData, providerId: string) => {
    if (!formData.leadAccount || !providerId) {
      return null;
    }

    const { data: leadAccountData, error: leadAccountError } = await supabase
      .from('lead_account')
      .insert([{
        external_id: formData.leadAccount.external_id,
        exchange: formData.leadAccount.exchange,
        active: formData.leadAccount.active,
        strategy_provider_id: providerId
      }])
      .select('id')
      .single();
      
    if (leadAccountError) {
      throw new Error(`Error creating lead account: ${leadAccountError.message}`);
    }
    
    return leadAccountData.id;
  };

  return { createLeadAccount };
};
